import React, { Component,Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, reduxForm, change,
	formValueSelector,stopAsyncValidation,touch } from 'redux-form'
import {getFormValues} from 'redux-form/immutable'
import { DefaultPlayer as Video } from 'react-html5video'
import map from 'async/map'
import isEmpty from 'lodash/isEmpty'
import bindAll from 'lodash/bindAll'
import Promise from 'bluebird'
import $ from 'jquery'
import snakeCase from 'voca/snake_case'
import UAParser from 'ua-parser-js'
import imgDefaultLogo from '../../../images/public/company_empty.png'
import imgSubmitted from '../../../images/submitted.svg'
import imgAppStore from '../../../images/public/appstore.png'
import imgGooglePlay from '../../../images/public/googleplay.png'
import imgAstrntFooter from '../../../images/public/logo-astronaut.svg'
import ProgressBarAngga from '../../partials/ProgressBarAngga'
import validate from './customValidation'
import CheckBoxGroup from '../../partials/CheckBoxGroup'
// import validate from './validate'
import { List, Map, OrderedMap, fromJS } from 'immutable'
// import Swal from 'sweetalert2'
import _axios from '../../../dependencies/_axios'
import SweetAlert from 'sweetalert-react'
// import { EmailShareButton, FacebookShareButton, TwitterShareButton, LinkedinShareButton, WhatsappShareButton } from 'react-share'
import moment from 'moment'
import {
	publicJobGetDetail,
	registrationSaveData,
	publicJobGetDetailAsync,
	registrationSaveDataError
} from '../../../actions/public/companies'


import {
    t
} from '../../../helpers/global'

import {
	globalHideSweetAlert,
	globalAddSweetAlertData
} from '../../../actions/global'

require('es6-promise').polyfill()

export const fields = ['file']

type State = {
  isConsent: boolean,
  isSaved: boolean
};

const normalizeEmail = (value, previousValue) => {
	return value.trim()
}

const normalizeTextLenght = (value,previousValue,maxWords)=>{
		let countText;
		if (value.trim().length == 0) {
      countText = 0;
    } else {
      countText = value == "" ? 0 : value.match(/\S+/g).length;
    }

		if (countText <= maxWords  ) {
			return value
		}else{
			return previousValue
		}
	}

class CompanyJobDetail extends Component {
	constructor(props) {
		super(props)

		this.state = {
			file: '',
			experience: '0',
			name: '',
			email: '',
			code: '',
			url: '',
			isConsent: false,
			isCompliance:false,
			isSaved: false,
			uploadFilePercentage:'',
			testColor:'#564FDB',
			uploadProgress:'',
			cvName:'',
		}

		bindAll(this, [
			'handleSaveData',
			'imageOnError',
			'renderError',
			'renderErrorCV',
			'removeRegexCharacter',
			'handleFileUpload',
			'checkExperience',
			'removeSpaceCharacter',
			'handleConsentClick',
			'handleClickAfterSave',
			'handleFileSave',
			'handleChangeTextArea',
			'inputFocus',
			'inputBlur',
			'handlePopUp',
			'countWord',
			'resizeTextArea',
			'removeErrorMessage'
		])
	}

	countWord(value){
		
			if (value) {
						let countText;
							if (value.trim().length == 0) {
								countText = 0;
							} else {
								countText = value == "" ? 0 : value.match(/\S+/g).length;
							}
							return countText
			}	else{
				return 0
			}
			
	
	}


	handlePopUp(value){
		var thisPageURL = window.location.href
		var url = ''
		if(value == 'facebook'){
			  url = 'https://www.facebook.com/sharer/sharer.php?&u='+thisPageURL
				// 'http://www.facebook.com/dialog/feed?'+
				//	'app_id='+thisPageURL
				// 			'link='+thisPageURL+
				// 			'message=Join us. Click here: '+thisPageURL
		}
		if(value == 'Whatsapp'){
			  url = 'https://web.whatsapp.com/send?text=Join us. Click here: '+thisPageURL
		}
		if(value == 'linkedin'){
			  url = 'https://www.linkedin.com/sharing/share-offsite/?url='+thisPageURL
		}
		if(value == 'twitter'){
			  url = 'https://twitter.com/intent/tweet?url='+thisPageURL+'&text=Join us. Click here: '
		}
		if(value == 'email'){
			  url ='https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&body=Join us. Click here: '+thisPageURL
		}
		window.open(url,'popUpWindow','height=600,width=600,left=400,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes')
	}
	inputFocus(e:object):void{
		const {publicJobCustom}= this.props
		e.target.style.boxShadow = `0 0 10px ${publicJobCustom.color}`;
		e.target.style.border = `1px solid ${publicJobCustom.color}`;
		e.target.style.borderRadius = `5px`;
	}

	inputBlur(e:object):void{
	 	e.target.style.border = `1px solid #999999`
		 e.target.style.borderRadius= ``
		 e.target.style.boxShadow=``
	}

	handleChangeTextArea(e){
		const{changeFieldValue}=this.props
		const wordCount =
      e.target.value === "" || e.target.value.match(/\S+/g) == null
        ? 0
		: e.target.value.match(/\S+/g).length;		
		if (wordCount>1000) {
			
		}else{
			changeFieldValue('experience',e.target.value)
		}
	}

	resizeTextArea(e, addInfoId) {
		this.removeErrorMessage(addInfoId)
		var text = e.target
		
		var x = window.scrollX,
		  y = window.scrollY;
		text.style.height = "auto";
		text.style.height = text.scrollHeight + "px";
		text.style.overflowY = "hidden";
		text.scrollTop = text.scrollHeight;
		text.focus();
		window.scrollTo(x, y);
	}

	removeErrorMessage(addInfoId) {
		var elm = document.getElementById('js-is-error-mandatory-' + addInfoId)
		if(elm) {
			elm.innerHTML = ''
		}
	}

	handleFileSave(e){
		const{formValues,
		changeFieldValue,
		registrationSaveDataError}=this.props
		const data = new FormData();
		const file = e.target.files[0]
	
		if (typeof file != 'undefined') {
			if(file.size > 5000000){
				registrationSaveDataError(
					{file: ["file type cannot more than 5 MB."]}
				)
				this.setState({cvName:''})
			}else{
				registrationSaveDataError({})
				this.setState({uploadProgress:'up'})
					data.append("file", file  || []);
					data.append("type", "cv" || []);
					_axios({
						url: `/upload-cv`,
						timeout: 200000,
						method: 'post',
						data,
						onUploadProgress: progressEvent => {
							this.setState({cvName:file.name})
							const uploadPercentage = Math.round(
								(progressEvent.loaded * 100) / progressEvent.total
							);
							this.setState({uploadFilePercentage:uploadPercentage})
							
	
							// dispatch({
							//   type: "INTERVIEWS_ADD_UI_UPLOAD_VIDEO_PERCENTAGE_SUCCESS",
							//   upload_video_percentage: uploadVideoPercentage
							// });
						}
					})
					.then((data) => {
						registrationSaveDataError({})
						const fileresponse=data.data.file_name
						const filename = fileresponse.substring(fileresponse.lastIndexOf('/')+1);
						changeFieldValue('cv', fileresponse)
						this.setState({file:filename})
						this.setState({uploadProgress:'done'})
						console.log('success')
					})
					.catch((error) => {
						changeFieldValue('cv', '')
						this.setState({file:''})
						registrationSaveDataError(error.response.data.message)
						this.setState({uploadProgress:''})
						console.log('fail')
					})
	
			}
		}
		
		
		
	}

	handleConsentClick(e) {
		
		if (e.target.name == 'gdpr') {
			this.setState({isConsent: !this.state.isConsent})
		}
		if (e.target.name == 'compliance') {
			this.setState({isCompliance: !this.state.isCompliance})
		}
    
  }


	componentDidMount(){
		const { publicJobDetail,publicJobGetDetail } = this.props
		
		publicJobGetDetail(this.props.companySlug, this.props.jobSlugs)
	
		// const company = JSON.parse(document.querySelector('#js-public-index-component').dataset.company)
		
		var timesRun=0
		
		this.setState({ name: '', email: '', code: '' })
		
		var interval=setInterval(() => {
			 timesRun += 1;
			if(timesRun === 100){
        clearInterval(interval);
   		 }

				$('li').each(function() {
						var $this = $(this);
					if($this.attr('style')){
						// console.log($(this).attr('style'));
						// $this.parent().addClass("class-new");
					}else{
						$this.attr("style", "list-style-position:outside")
					}
				});
			
      $('.rh5v-Overlay_inner').css('background-color', this.props.publicJobCustom.color)
    }, 100);
		
	
		

	}

	

	checkExperience(value) {
		this.setState({experience: value})
	}

	handleFileUpload(e) {
		e.preventDefault()

		const file = e.target.files[0]

		this.setState({file})
	}

	removeRegexCharacter(str) {
		return str.replace(/[^0-9]/g, '')
	}

	removeSpaceCharacter(str) {
		return str.replace(/\s/g, '')
	}

	imageOnError() {
		const {
			publicJobDetail,
			publicJobGetDetailAsync
		} = this.props

		publicJobDetail.company.logoUrl = imgDefaultLogo

		publicJobGetDetailAsync(publicJobDetail)
	}
	handleClickAfterSave(){
		if(this.state.isSaved == true){
			var form = $("#form-registration").serializeArray();
			var returnArray = {};
	        for (var i = 0; i < form.length; i++){
	          returnArray[form[i]['name']] = form[i]['value'];
			}
	    $('#btn-submit').prop('disabled',true)
	    this.handleSaveData(returnArray)
		}
	}
	handleSaveData(values) {
		const {
			registrationSaveData,
			publicJobDetail,
			translationjob,
			error_email_exists,
			companySlug,
			jobSlugs,
			globalHideSweetAlert,
			globalAddSweetAlertData,
			publicJobCustom,
			touchForm,
			stopAsyncValidationForm,
			formState,
		} = this.props
		const {
			file,
			experience
		} = this.state
		// console.log(values)
		var colorCustom = publicJobCustom.color

		const company = publicJobDetail.company || {}
	
		const detailJob : Map<string, any> = fromJS({detailInfo:translationjob})
		this.setState({isSaved: true})
		const translation = detailJob.get('detailInfo')
		// const company = JSON.parse(document.querySelector('#js-public-index-component').dataset.company)
		return new Promise((resolve, reject) => {
			map(values, (data, callback) => {
				const phones = values.phone
				const emails = values.email
				const escapedPhoneValue = this.removeRegexCharacter(phones)
				const escapedEmailValue = this.removeSpaceCharacter(emails)

				if (escapedPhoneValue) {
					values.phone = escapedPhoneValue
				}
				if (escapedEmailValue) {
					values.email = escapedEmailValue
				}
				callback(null, values)
			}, (error, results) => {
				// console.log(results)
				let isErrorMandatory = false
				console.log(publicJobDetail.additionalField)
				map(publicJobDetail.additionalField, (addinfo, callback) => {
					let value = ''

					if (addinfo.id === 77) {
						value = experience
					} else if (addinfo.input_type==1 || addinfo.input_type==0 ) {
							value = document.getElementsByClassName('js-additional-fields-'+addinfo.id)[0].value
					}else if(addinfo.input_type==2){
							value = formState[`${snakeCase(addinfo.label)}-${addinfo.id}`] || []
					}
					// console.log(value)
					if (addinfo.input_type==2 ) {
						if (addinfo.is_mandatory !== 0 && value.length < 1) {
								isErrorMandatory = true
								document.getElementById('js-is-error-mandatory-'+addinfo.id).innerHTML = `${addinfo.label} Field can't be blank`
								document.getElementById('btn-submit').removeAttribute("disabled")
							}else{
								isErrorMandatory = false

								document.getElementById('js-is-error-mandatory-'+addinfo.id).innerHTML = ""
								callback(null, {id : addinfo.id, value: value, is_mandatory: addinfo.is_mandatory, label : addinfo.label})
							}
					
					}else{

						if (isEmpty(value) && addinfo.is_mandatory !== 0) {
						isErrorMandatory = true
						document.getElementById('js-is-error-mandatory-'+addinfo.id).innerHTML = `${addinfo.label} Field can't be blank`
						document.getElementById('btn-submit').removeAttribute("disabled")
						}else if(addinfo.minWords && addinfo.is_mandatory !== 0){
							//checker for minwords
							if (this.countWord(value) < addinfo.minWords) {
								isErrorMandatory = true
								document.getElementById('js-is-error-mandatory-'+addinfo.id).innerHTML = `${addinfo.label} at least have ${addinfo.minWords} words`
								document.getElementById('btn-submit').removeAttribute("disabled")
							}else{
								isErrorMandatory = false

								document.getElementById('js-is-error-mandatory-'+addinfo.id).innerHTML = ""
								console.log('masuk callback')
								callback(null, {id : addinfo.id, value: value, is_mandatory: addinfo.is_mandatory, label : addinfo.label})
							}
							
						}	else {
							isErrorMandatory = false

							document.getElementById('js-is-error-mandatory-'+addinfo.id).innerHTML = ""
							console.log('masuk callback')
							callback(null, {id : addinfo.id, value: value, is_mandatory: addinfo.is_mandatory, label : addinfo.label})
						}

					}
					
				}, (error, results) => {
					values.custom_fields = results
					values.file_cv = file

					if (isErrorMandatory === false) {
						registrationSaveData(values, companySlug, jobSlugs)
						.then((data) => {
							this.setState({ name: values.fullname, email: values.email, code: data.interview_code, url: data.url })
					
							
							globalAddSweetAlertData({
							show: true,
							type: 'success',
							title: t(
									translation.get('translation'),
								'MODAL_SUCCESS_REGISTER_TITLE'
        		),
							html: true,
							text: t(
									translation.get('translation'),
								'MODAL_SUCCESS_REGISTER_MESSAGE',
								{
										':candidate_fullname': values.fullname,
										':candidate_interview_code': data.interview_code,
										':candidate_email':values.email,
										':company_name':company.title
								}
        		),
							confirmButtonText: t(translation, 'MODAL_SUCCESS_BUTTON'),
							confirmButtonColor: colorCustom,
							onConfirm: () => {
								window.location = data.url
								globalHideSweetAlert()
							}
							})
						

							// $('#registration-form').addClass("hide")
							// $('#registration-form__success').removeClass("hide")
							$('.js-job-detail-file').val('')

							this.setState({file: ''})

							return Promise.resolve()
						})
						.catch((error) => {
							this.setState({isSaved: false})
							if (typeof error.response == "undefined") {
							
							}else if(error.response.data.message == 'Our system is detecting that you have already applied to this job. You cannot apply twice. Please contact help@astrnt.co if you think there is an error'){
								// dispatch(registrationSaveDataError(error.response.data))
								touchForm(['email'])
								stopAsyncValidationForm({email:'Email is already registered'})
								// console.log(error.response.data.message)
								
							}
							reject(error)
						})
					} else {
						reject()
					}
				})
			})
		})
	}
	renderError({ meta: { touched, error } }) {
		const {
			translationjob
		} = this.props
		const translations : Map<string, any> = fromJS(translationjob.translation)
		return touched && error ? <div><span className="error normal" id="js-err-msg">{t(translations, error)}</span></div> : false
	}

	renderErrorCV({ meta: { touched, error } }) {
		const {publicJobDetail,translationjob} = this.props
		const job = publicJobDetail.job 
		const translations : Map<string, any> = fromJS(translationjob.translation)
		return touched && error ? <div><span className="error normal" id="js-err-msg">{job.document_type+t(translations, error)}</span></div> : false
	}

	renderSubmitSuccess() {
		const parser: Object = new UAParser();
		const isMobile: boolean = parser.getDevice().type === 'mobile'

		if (isMobile) {
			const isiOS: boolean = parser.getOS().name === 'iOS'
			let sourceLogo: Object

			if (isiOS) {
				sourceLogo =
					<a href="https://itunes.apple.com/id/app/astronaut-always-be-interviewing/id1098124247?mt=8">
						<img src={imgAppStore} />
					</a>
			} else {
				sourceLogo =
					<a href="https://play.google.com/store/apps/details?id=co.astrnt.androidqa">
						<img src={imgGooglePlay} />
					</a>
			}
			return (
				<div className="big-panel p-40">
					<div className="text-center">
						<img src={imgSubmitted} className="m-b-24" alt="Application Submitted" />
						<h1 className="heading2 m-b-24">Application Submitted</h1>
						<p className="heading4 p-b-24">Congratulations, <b>{this.state.name}!</b> You have successfully applied for this opportunity. We have sent an email to <b>{this.state.email}</b> with a link to the interview.</p>
					</div>
					<p className="heading4">Don't want to wait? You can do the interview now.</p>
					<p className="heading4">Steps:</p>
					<p className="heading4">1. Download the Astronaut Q&A app here:</p>
					{sourceLogo}
					<p className="heading4">2. Once you have installed the app, <a href={this.state.url} className="text-inherit underline">Click here</a> to launch the app and start your Q&A session</p>
				</div>
			)
		} else {
			return (
				<div className="big-panel text-center p-40">
					<img src={imgSubmitted} className="m-b-24" alt="Application Submitted" />
					<h1 className="heading2 m-b-24">Application Submitted</h1>
					<p className="heading4 p-b-24">Congratulations, <b>{this.state.name}!</b> You have successfully applied for this opportunity. We have sent an email to <b>{this.state.email}</b> with a link to the interview.</p>
					<p className="heading4">Don't want to wait? <a href={this.state.url} className="text-inherit underline">Click here</a> to do the interview right now, or enter the code <b>{this.state.code}</b> on the Astronaut Q&A app.</p>
				</div>
			)
		}
	}

 createMarkup(message) {
		return {__html: message};
	}

	render() {
		const {
			fields: {file},
			publicJobDetail,
			handleSubmit,
			submitting,
			pristine,
			errors,
			globalAddSweetAlertData,
			error_email_exists,
			globalSweetAlertData,
			formValues,
			publicJobCustom,
			translationjob,
			formState,
		} = this.props

		console.log('Prop', this.props);
		const { experience,
		 isConsent,
		 isCompliance,
		 testColor,
		 uploadProgress,
		 cvName } = this.state
		//  console.log(formState)
		var countText: Number;
    const text_answer: String = formValues.experience==undefined ? '': formValues.experience;
		document.styleSheets[0].addRule('.main-gdpr-fluid .checkbox-container .checkmark:after', 'border: solid '+this.props.publicJobCustom.color+';');
    if (text_answer.trim().length == 0 ) {
      countText = 0;
    } else {
      countText = text_answer == "" ? 0 : text_answer.match(/\S+/g).length;
    }
	const translations : Map<string, any> = fromJS(translationjob.translation)
		// console.log(error_email_exists.toJS())
		const thisPageURL = window.location.href
		const company = publicJobDetail.company || {}
		const customColor = publicJobCustom.color
		const backgroundImage = publicJobCustom.backgroundImage
		const socialMedia = publicJobCustom.social_media
		
		const job = publicJobDetail.job || {}
		const dueDate = moment(job.due_date).format("DD MMM YYYY")
		const additionalField = publicJobDetail.additionalField || []
		const gdpr_text = publicJobDetail.gdpr_text || []
		const gdpr_agreement_text = publicJobDetail.gdpr_aggrement_text || []
		const job_document_type = job.document_type == 'CV' ? 'Curriculum Vitae' : 'Company Investment Profile'
		const job_video_url = publicJobDetail.job ? publicJobDetail.job.introduction_video.job_video_url : ''
		const video = document.getElementById('video-src')

		let finalWidth = '100%'
		let videoStyle = {
			'width' : finalWidth,
			'borderRadius' : '10px',
		}
		$('.m-t-30 .button__primary').css('background-color', customColor)
		var iconClass;
		var iconColor;
		if (uploadProgress=='') {
			iconClass='fa-cloud-upload'
			iconColor='#999999'
		} else if (uploadProgress=='up') {
			iconClass='fa-soundcloud'
			iconColor=customColor
		} else if (uploadProgress=='done') {
			iconClass='fa-cloud'
			iconColor=customColor
		}
			if(video){
				video.onloadedmetadata = function() {
					if(video.videoHeight > video.videoWidth){
						video.style.width = '40%'
						video.style.left = '30%'
						video.style.position = 'relative'
					}
					if(video.videoHeight == video.videoWidth){
						video.style.width = '60%'
						video.style.left = '20%'
						video.style.position = 'relative'
					}
				}
			}
		return(
			<Fragment>
			{
				customColor=='' ? 
				<div/>
				:
				<Fragment>
				 <div>
					<header className="header-career" style={{background:"url("+backgroundImage+")"+customColor}} >
						<div className={`container ${backgroundImage=='' || backgroundImage==null || backgroundImage==0? '': 'invisible'}`}>
							<div className="flex-container img-container m-r-10 float-align-left">
								<a href={company.website}
									className="text-white"
									target="_blank"
									rel="noopener noreferrer">
									<img
										className="company-logo img-responsive"
										src={company.logoUrl}
										alt={company.title}
										onError={this.imageOnError} />
								</a>
							</div>
							<div className="header-detail vertical-item--center flex-between float-align-right text-right">
								<div>
									<h3 className="heading3 m-b-5">{job.title}</h3>
									<p className="font-16">{!isEmpty(job.jobType) ? <span>{job.jobType}</span>: '' }{!isEmpty(job.due_date) ? <span className="m-l-10">&bull;&nbsp;&nbsp;{t(translations, "LABEL_DUE_DATE")} <b>{dueDate} {job.timezone ? job.timezone.suffix : '(GMT+7)'}</b></span>: '' }</p>
								</div>
							</div>
						</div>
					</header>
					<section className="p-t-40 p-b-24 bg-gray" id="registration-form">
						<div className="container">
							<div className="row">
								<div className="col-sm-7 col-md-7">
									<div>
										{isEmpty(job_video_url) ?
											''
											:
											<div className="video-box">
												<Video style={videoStyle} id="video-src" src={job_video_url}>
												</Video>
											</div>
										}
										<div className="div-apply-now-button mobile-hide"><a href="#section-registration"><button className="button button__primary button--medium medium-rounded button-apply-now" style={{backgroundColor:customColor, borderColor:customColor}}>APPLY NOW <i className="fa fa-chevron-down font-18"></i></button></a></div>
										<section>
												<div className="div-wisiwig" dangerouslySetInnerHTML={this.createMarkup(job.aboutDescription)}  />
										</section>
										<section className={`div-soc-container flex-container flex-between align-items-center m-t-40 ${socialMedia.length>0 ?'':'hidden'}`}>
												<div>SHARE</div>
												<div className="desktop-hide">
													<div className="flex-container">
														<a onClick={() => this.handlePopUp('email')} title="Email" className={socialMedia.includes('email') ? '' : 'hide'}><div className="div-soc-med flex-container flex-between align-items-center email">Email<i className="fa fa-envelope"></i></div></a>
														<a onClick={() => this.handlePopUp('facebook')} title="Facebook" className={socialMedia.includes('facebook') ? '' : 'hide'}><div className="div-soc-med flex-container flex-between align-items-center facebook">Facebook<i className="fa fa-facebook-official"></i></div></a>
														<a onClick={() => this.handlePopUp('twitter')} title="Twitter" className={socialMedia.includes('twitter') ? '' : 'hide'}><div className="div-soc-med flex-container flex-between align-items-center twitter">Twitter<i className="fa fa-twitter"></i></div></a>
														<a onClick={() => this.handlePopUp('linkedin')} title="LinkedIn" className={socialMedia.includes('linkedin') ? '' : 'hide'}><div className="div-soc-med flex-container flex-between align-items-center linkedin">LinkedIn<i className="fa fa-linkedin"></i></div></a>
														<a onClick={() => this.handlePopUp('Whatsapp')} title="WhatsApp" className={socialMedia.includes('Whatsapp') ? '' : 'hide'}><div className="div-soc-med flex-container flex-between align-items-center whatsapp">WhatsApp<i className="fa fa-whatsapp"></i></div></a>
													</div>
												</div>
												<div className="mobile-hide">
													<div className="flex-container">
														<a onClick={() => this.handlePopUp('email')} title="Email" className={socialMedia.includes('email') ? '' : 'hide'}><div className="div-soc-med-small flex-container flex-between align-items-center email"><i className="fa fa-envelope"></i></div></a>
														<a onClick={() => this.handlePopUp('facebook')} title="Facebook" className={socialMedia.includes('facebook') ? '' : 'hide'}><div className="div-soc-med-small flex-container flex-between align-items-center facebook"><i className="fa fa-facebook-official"></i></div></a>
														<a onClick={() => this.handlePopUp('twitter')} title="Twitter" className={socialMedia.includes('twitter') ? '' : 'hide'}><div className="div-soc-med-small flex-container flex-between align-items-center twitter"><i className="fa fa-twitter"></i></div></a>
														<a onClick={() => this.handlePopUp('linkedin')} title="LinkedIn" className={socialMedia.includes('linkedin') ? '' : 'hide'}><div className="div-soc-med-small flex-container flex-between align-items-center linkedin"><i className="fa fa-linkedin"></i></div></a>
														<a onClick={() => this.handlePopUp('Whatsapp')} title="WhatsApp" className={socialMedia.includes('Whatsapp') ? '' : 'hide'}><div className="div-soc-med-small flex-container flex-between align-items-center whatsapp"><i className="fa fa-whatsapp"></i></div></a>
													</div>
												</div>
										</section>
									</div>
								</div>
								<div className="col-sm-5 col-md-5">
									{publicJobDetail.invite ?
											<section id="section-registration" className="registration">
												<div className="div-apply-now">
													<p style={{color:customColor}}>{t(translations, "LABEL_APPLY_NOW")}</p>
													<hr style={{borderColor:customColor}}/>
												</div>
												<form onSubmit={handleSubmit(this.handleSaveData)} id="form-registration" className="vertical-form">
													<div className="form-group">
													<Field
														name="company_id"
														type="hidden"
														component="input"/>
													<Field
														name="job_id"
														type="hidden"
														component="input"/>
													<Field
														name="interview_code"
														type="hidden"
														component="input"/>
													<label>{t(translations, "LABEL_FULL_NAME")}</label>
														<Field
															name="fullname"
															type="text"
															onFocus={this.inputFocus}
															onBlur={this.inputBlur}
															placeholder={t(translations, 'LABEL_FULL_NAME')}
															component="input" />
														<Field name="fullname" component={this.renderError}/>
													</div>
													<div className="form-group">
														<label>{t(translations, 'LABEL_PREFERRED_NAME')}</label>
														<Field
															name="preferred_name"
															type="text"
															onFocus={this.inputFocus}
															onBlur={this.inputBlur}
															placeholder={t(translations, 'LABEL_PREFERRED_NAME')}
															component="input" />
														<Field name="preferred_name" component={this.renderError}/>
													</div>
													<div className="form-group">
														<label>{t(translations, 'LABEL_EMAIL_ADDRESS')}</label>
														<Field
															name="email"
															type="text"
															onFocus={this.inputFocus}
															onBlur={this.inputBlur}
															placeholder={t(translations, 'LABEL_EMAIL_ADDRESS')}
															component="input"
															normalize={normalizeEmail} />
														<Field name="email" component={this.renderError}/>
													</div>
													<div className="form-group">
														<label>{t(translations, 'LABEL_CONFIRM_EMAIL_ADDRESS')}</label>
														<Field
															name="email2"
															type="text"
															onFocus={this.inputFocus}
															onBlur={this.inputBlur}
															placeholder={t(translations, 'LABEL_CONFIRM_EMAIL_ADDRESS')}
															component="input"
															normalize={normalizeEmail} />
														<Field name="email2" component={this.renderError}/>
													</div>
													<div className="form-group">
														<label>{t(translations, 'LABEL_MOBILE_NUMBER')}</label>
														<Field
															name="phone"
															type="text"
															onFocus={this.inputFocus}
															onBlur={this.inputBlur}
															placeholder={t(translations, 'LABEL_MOBILE_NUMBER')}
															component="input" />
														<Field name="phone" component={this.renderError}/>
													</div>
													{job.requireCv !== 0 ?
													<div className="form-group">
														<div className="row m-0">
															<div className="col-md-5 p-0"><label>{job_document_type}</label></div>
															<div className="col-md-7 text-use-pdf p-0"><label className="normal">Use *.pdf format & max. 5MB</label></div>
														</div>
														<div className="row m-0">
															<div className="input-group m-t-5">
																<label className="form-control upload-cv b-r-0 m-t-0">
																	<p className="cv-file">{cvName==''?job_document_type:cvName}</p>
																	<p className="uploaded-cv"></p>
																	<input
																	name="cv"
																	type="file"
																	className="upload-cv"
																	placeholder="Curriculum Vitae"
																	onChange={this.handleFileSave}
																	component="input" />
																	
																	
																<Field
																	name="cv"
																	type="text"
																	className="hidden"
																	placeholder="Curriculum Vitae"
																	component="input" />
																</label>
																<span className="input-group-addon input-group-addon-up-cv"><i className={`fa ${iconClass} font-28`} style={{color:iconColor}}></i></span>
															</div>
															{uploadProgress == 'up'?
															<ProgressBarAngga progressVal={this.state.uploadFilePercentage}/>
															: null}
															{!isEmpty(errors) ? <span className="error">{errors.file}</span> : <Field name="cv" component={this.renderErrorCV}/>}
															
															
														</div>
													</div>
													: null
													}
													<div className="form-group hidden">
														<div className="col-md-10 p-0"><label>What of experience do you expect to gain at <a href="https://astrnt.co" target="_blank"><b style={{color:customColor}}>Astronaut</b></a>?</label></div>
														<div className="col-md-2 text-right p-0"><label>{countText}<font className="normal">/1000</font></label></div>
														<textarea
															name="experience"
															onFocus={this.inputFocus}
															onBlur={this.inputBlur}
															value={formValues.experience}
															onChange={this.handleChangeTextArea}
															placeholder="What of experience do you expect to gain at Astronaut?"
															className="form-control h-100"
														/>
														
														<Field
															name="experience"
															component="textarea"
															placeholder="What of experience do you expect to gain at Astronaut?"
															className="form-control h-100 hidden" />
														<Field name="experience" component={this.renderError}/>
													</div>
													{additionalField.map((addInfo, index) => (
														<div key={index}>
															{addInfo.id === 77 ?
																<div className="form-group m-t-30">
																	<div className="label capitalize">{addInfo.label}</div>
																	<div className="form-group sm">
																		<Field
																			name={`${snakeCase(addInfo.label)}-${addInfo.id}`}
																			type="radio"
																			className={`js-additional-fields-${addInfo.id}`}
																			component="input"
																			onChange={() => this.checkExperience('0')}
																			checked={experience === '0'}/> Less than 1 year
																	</div>
																	<div className="form-group sm">
																		<Field
																			name={`${snakeCase(addInfo.label)}-${addInfo.id}`}
																			type="radio"
																			className={`js-additional-fields-${addInfo.id}`}
																			component="input"
																			onChange={() => this.checkExperience('1')}
																			checked={experience === '1'}/> 1 year
																	</div>
																	<div className="form-group sm">
																		<Field
																			name={`${snakeCase(addInfo.label)}-${addInfo.id}`}
																			type="radio"
																			className={`js-additional-fields-${addInfo.id}`}
																			component="input"
																			onChange={() => this.checkExperience('2')}
																			checked={experience === '2'}/> More than 1 year
																	</div>
																	<div><span id={`js-is-error-mandatory-${addInfo.id}`} className="error"></span></div>
																</div>
																:
																[
																	addInfo.input_type == 1 ?
																	<div className="form-group" key ={index}>
																		<label><span className="capitalize">{addInfo.label}</span>{addInfo.is_mandatory !== 1 ? ' (optional)' : ''}</label>
																		{addInfo.description ? <label className="label-desc">{addInfo.description}</label> : null}
																		{addInfo.maxWords? 	<label className="label-desc"><b>{this.countWord(formState[`${snakeCase(addInfo.label)}-${addInfo.id}`])}</b>/{addInfo.maxWords} Words (at least {addInfo.minWords})</label> :null}
																		{addInfo.maxWords?
																			<Field
																			name={`${snakeCase(addInfo.label)}-${addInfo.id}`}
																			onFocus={this.inputFocus}
																			onBlur={this.inputBlur}
																			normalize={(value,previousValue)=>normalizeTextLenght(value,previousValue,addInfo.maxWords)}
																			className={`js-additional-fields-${addInfo.id}`}
																			component="textarea"
																			onChange={(e)=>this.resizeTextArea(e,addInfo.id)}
																			placeholder={addInfo.label}
																			/>
																		:
																			<Field
																			name={`${snakeCase(addInfo.label)}-${addInfo.id}`}
																			onFocus={this.inputFocus}
																			onBlur={this.inputBlur}
																			className={`js-additional-fields-${addInfo.id}`}
																			component="textarea"
																			onChange={(e)=>this.resizeTextArea(e,addInfo.id)}
																			placeholder={addInfo.label}
																			/>
																		}
																	
																		<div><span id={`js-is-error-mandatory-${addInfo.id}`} className="error"></span></div>
																	</div>
																	:

																	[addInfo.input_type == 2 ? 
																		<div className="form-group">
																			<label>{addInfo.label} <span className="normal">{addInfo.is_mandatory !== 1 ? ' (Optional)' : ''}</span></label>
																			{addInfo.description ?<label className="label-desc">{addInfo.description}</label>:null}
																			{addInfo.maxOptions ?<label className="label-desc">Max. choose {addInfo.maxOptions} options</label>:null}
																			{addInfo.maxOptions?
																				<Field
																						name={`${snakeCase(addInfo.label)}-${addInfo.id}`}
																						component={CheckBoxGroup}
																						options={addInfo.options}
																						maxOptions={addInfo.maxOptions}
																						onChange={(e)=>this.removeErrorMessage(addInfo.id)}
																					/>
																			:
																				<Field
																						name={`${snakeCase(addInfo.label)}-${addInfo.id}`}
																						component={CheckBoxGroup}
																						options={addInfo.options}
																						onChange={(e)=>this.removeErrorMessage(addInfo.id)}
																					/>
																			}
																			
																			<div><span id={`js-is-error-mandatory-${addInfo.id}`} className="error"></span></div>
																		</div>
																	:

																		<div className="form-group">
																				<label><span className="capitalize">{addInfo.label}</span>{addInfo.is_mandatory !== 1 ? ' (optional)' : ''}</label>
																				{addInfo.description ? <label className="label-desc">{addInfo.description}</label> : null}
																				<Field
																					name={`${snakeCase(addInfo.label)}-${addInfo.id}`}
																					onFocus={this.inputFocus}
																					onBlur={this.inputBlur}
																					type="text"
																					placeholder={addInfo.label}
																					className={`js-additional-fields-${addInfo.id}`}
																					component="input"
																					onChange={(e)=>this.removeErrorMessage(addInfo.id)}/>
																				<div><span id={`js-is-error-mandatory-${addInfo.id}`} className="error"></span></div>
																			</div>
																	
																	]
																	
																]
															
															}
														</div>
													))}


													<div 
													className={`form-group main-gdpr-fluid ${publicJobDetail.compliance? 
																		isConsent && isCompliance ? "is-on" : ""
																	  : 
																		isConsent ? "is-on" : ""}`}
													 style={publicJobDetail.compliance?
													 				 isConsent && isCompliance ? {backgroundColor:customColor}:{}
																		:
																	 isConsent ? {backgroundColor:customColor}:{}}>
														<label className="label-gdpr-text">{gdpr_text}</label>
														<label className="inline-content normal checkbox-container m-b-15">
															<Field
																name="gdpr"
																type="checkbox"
																onClick={this.handleConsentClick}
																component="input"
																checked={isConsent}
																className="btn-checkbox m-r-10" />{gdpr_agreement_text}<span className="checkmark"></span>
														</label>
														{publicJobDetail.compliance?
														<label className="inline-content normal checkbox-container" style={{whiteSpace: 'pre-wrap'}}>
															<Field
																	name="compliance"
																	type="checkbox"
																	onClick={this.handleConsentClick}
																	component="input"
																	checked={isCompliance}
																	className="btn-checkbox m-r-10" />{publicJobDetail.compliance}<span className="checkmark"></span>
														
														</label>
														:
														null}
														
													</div>

													<center className="m-t-30">
														<p className="label-click-continue" dangerouslySetInnerHTML={{__html: t(translations, 'LABEL_CONTINUE_DESC')}}/>
														<button
															id="btn-submit"
															type="submit"
															className={`button button__primary button--medium medium-rounded button-continue ${this.state.isConsent ? "is-on" : ""}`}
															onClick={this.handleClickAfterSave}
															disabled={publicJobDetail.compliance? isConsent && isCompliance? false:true 
															:
															!isConsent}>{t(translations, 'BUTTON_CONTINUE')}<i className="fa fa-chevron-right"></i></button>
													</center>
												</form>
											</section>
										:
										''
									}
								</div>
							</div>
						</div>
					</section>
					<section className="p-t-24 p-b-24 hide animate-all" id="registration-form__success">
						<div className="container">
							{this.renderSubmitSuccess()}
						</div>
					</section>
					<div className="footer-astrnt">
									<section>
											Powered by <a><img src={imgAstrntFooter} /></a> All Rights Reserved.
									</section>
							</div>
					{/*
					<footer className="listing-footer">
						<div className="flex-container flex-between">
							<p><a href={company.website} target="_blank" rel="noopener noreferrer"><i className="fa fa-globe"></i> {company.website}</a></p>
							<div className="copy">
								<a href="http://astrnt.co">Powered by ASTRNT</a>
							</div>
						</div>
					</footer>
					*/}
					{/* <SweetAlert {...globalSweetAlertData} /> */}
				</div>
				</Fragment>
			}
			</Fragment>
			
		)
	}
}

CompanyJobDetail.propTypes = {
	errors: PropTypes.object,
	publicJobGetDetail: PropTypes.func.isRequired,
	companySlug: PropTypes.string,
	jobSlugs: PropTypes.string,
	registrationSaveData: PropTypes.func.isRequired,
	publicJobDetail: PropTypes.object.isRequired,
	fields: PropTypes.array.isRequired,
	publicJobGetDetailAsync: PropTypes.func.isRequired,
}

CompanyJobDetail = reduxForm({
  form: 'CompanyJobDetail',
	enableReinitialize: true,
	validate,
	fields
})(CompanyJobDetail)
const selector = formValueSelector('CompanyJobDetail')

const mapStateToProps = (state, ownProps) => {
	const formState = getFormValues('CompanyJobDetail')(state)
	const publicJobDetail = state.publicJobDetail.toJS()
	const company = publicJobDetail.company || {}
	const job = publicJobDetail.job || {}

	const initialValues = {
		company_id: company.id,
		job_id: job.id,
		interview_code: job.open_code,
		cv:'',
		experience:'',
	}
	

  return {
		publicJobDetail: state.publicJobDetail.toJS(),
		translationjob: state.publicJobDetail.toJS(),
		errors: state.registrationSaveDataError.toJS(),
		publicJobCustom: state.publicJobCustom.toJS(),
		error_email_exists: state.registrationEmailDuplicate,
		companySlug: ownProps.match.params.companySlug,
		jobSlugs: ownProps.match.params.jobSlugs,
		globalSweetAlertData: state.globalSweetAlertData.toJS(),
		initialValues,
		formValues: selector(
			state,
			'cv',
			'experience'
		),
		formState
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
		changeFieldValue: (field, value) => dispatch(change('CompanyJobDetail', field, value, true, true)),
		touchForm: (field) => dispatch(touch('CompanyJobDetail', field)),
		stopAsyncValidationForm: (object) => dispatch(stopAsyncValidation('CompanyJobDetail', object)),
		globalHideSweetAlert: () => dispatch(globalHideSweetAlert()),
		globalAddSweetAlertData: (options) => dispatch(globalAddSweetAlertData(options)),
		registrationSaveData: (companySlug, jobSlugs, values) => dispatch(registrationSaveData(companySlug, jobSlugs, values)),
		publicJobGetDetail: (companySlug, jobSlugs) => dispatch(publicJobGetDetail(companySlug, jobSlugs)),
		publicJobGetDetailAsync: (publicJobDetail) => dispatch(publicJobGetDetailAsync(publicJobDetail)),
		globalAddSweetAlertData:(option)=>dispatch(globalAddSweetAlertData(option)),
		globalHideSweetAlert:()=>dispatch(globalHideSweetAlert()),
		registrationSaveDataError:(error)=>dispatch(registrationSaveDataError(error)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyJobDetail)
